<app-cybersocxmenu></app-cybersocxmenu>
<div class="col-12">
    <app-incidentform
      (searchEmitter)="search()"
      handleAdvSearch="true"
      #incidentForm
      > </app-incidentform>
    <br />
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link" [ngClass]="{ active: page === 'highlevel' }" (click)="page = 'highlevel'">{{'pages.cybersocxdr.dashboard.fieldTitles.highlevel' | translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [ngClass]="{ active: page === 'backlog' }" (click)="page = 'backlog'"
                >{{ 'pages.cybersocxdr.dashboard.fieldTitles.backlog' | translate }}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [ngClass]="{ active: page === 'detailed' }" (click)="page = 'detailed'"
                >{{ 'pages.cybersocxdr.dashboard.fieldTitles.detailed' | translate }}
            </a>
        </li>
    </ul>


    <div class="row gx-2" *ngIf="page === 'highlevel'">
        <div class="col-12 col-xl-6 py-2">
          <app-filtermenu [items]="filterMenuItemsForHighLevelView">
            <app-pie
                class="card"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.incidentbyseverity' | translate }}"
                [createdTo]="createdTo"
                [createdFrom]="createdFrom"
                [data]="dashboardData"
                suffix=""
                innerSize= 150
                enabled3D="true"
                ></app-pie>
          </app-filtermenu>
        </div>
        <div class="col-12 col-xl-6 py-2 ">
            <app-areaovertime
                class="card"
                [isStacking]="true"
                [data]="incidentsOverTimedata"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.incidentbyseverityovertime' | translate }}"
                titleY="Number of incidents"
                suffix = "incidents"
            ></app-areaovertime>
        </div>

        <div class="col-12 col-xl-6 py-2">
          <app-filtermenu [items]="filterMenuItemsForHighLevelView">
            <app-incidentbyseveritycategory
                class="card"
                title="{{ 'pages.cybersocxdr.dashboard.fieldTitles.heatmapbyseverityandcategory' | translate }}"
                [data]="categoryHeatMapData"
            ></app-incidentbyseveritycategory>
          </app-filtermenu>
        </div>

        <div class="col-12 col-xl-6 py-2 ">
          <app-filtermenu [items]="filterMenuItemsForHighLevelView">
            <app-packedbubblehost
                class="card"
                [data]="bubbleHostnameData"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.packedbubblecategoryandseverity' | translate }}"
            ></app-packedbubblehost>
          </app-filtermenu>
        </div>

        <div class="col-12 py-2">
            <app-scatterpyramid
                class="card"
                [data]="pyramidIncidentData"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.PyramidAlerts' | translate }}"
            ></app-scatterpyramid>
        </div>

        <div class="col-12 py-2">
            <app-securitynavigatormanager
                class="card py-2 px-2"
                *ngIf="navigatorData && navigatorData.length > 0"
                [data]="navigatorData"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.securitynavigatormanager' | translate }}"
            ></app-securitynavigatormanager>
        </div>
    </div>
    <div class="row gx-2" *ngIf="page === 'backlog'">
        <div class="col-12 col-xl-6 py-2 ">
            <app-areaovertime
            class="card"
            title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.remediationtimebyseverity' | translate }}"
            [isStacking]="false"
            titleY="Days"
            [data]="opentimeavgData"
            suffix = "jours"
            ></app-areaovertime>
        </div>
        <div class="col-12 col-xl-6 py-2">
          <app-filtermenu [items]="filterMenuItemsForBacklogView">
            <app-pie
                class="card"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.openincidentsbyseverity' | translate }}"
                [createdTo]="createdTo"
                [createdFrom]="createdFrom"
                [data]="openDashboardData"
                suffix=""
                innerSize= 0
            ></app-pie>
          </app-filtermenu>
        </div>
        <div class="col-12 col-xl-6 py-2">
          <app-filtermenu [items]="filterMenuItemsForBacklogView">
            <app-barovertime
                class="card"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.openincidentbystatus' | translate }}"
                [data]="histogramOpenedIncidentsData"
            ></app-barovertime>
          </app-filtermenu>
        </div>
        <div class="col-12 col-xl-6 py-2">
          <app-filtermenu [items]="filterMenuItemsForBacklogView">
            <app-barovertime
                class="card"
                [isStacking]="false"
                title= "{{ 'pages.cybersocxdr.dashboard.fieldTitles.closuretyperepartition' | translate }}"
                [createdTo]="createdTo"
                [createdFrom]="createdFrom"
                [data]="histogramClosedIncidentsData"
                titleY="amount of closed incidents"
            ></app-barovertime>
          </app-filtermenu>
        </div>
    </div>
    <div class="row gx-2 pt-4" *ngIf="page === 'detailed'">
      <ng-container
          *ngIf="incidentsRepartitionData===null; then detailed_unavailable; else detailed_available">
      </ng-container>

      <ng-template #detailed_unavailable>
        <section class="card row card-body">
            <h1>{{ 'pages.cybersocxdr.dashboard.no_datas' | translate }}</h1>
            <img class="w-25 start-50" alt="{{ 'pages.cybersocxdr.dashboard.detailedView.noRepartitionData' | translate }}" src="/assets/images/icons/no_data.svg">
        </section>
      </ng-template>

      <ng-template #detailed_available>
        <h1 class="container-fluid no-gutters">{{ 'pages.cybersocxdr.dashboard.detailedView.repartition' | translate }}</h1>
        <div class="row justify-content-center gx-2">
          <div class="col-12 col-xl-6 pt-2 pb-4"
                *ngIf="isGeographicDataAvailable"
                >
          <app-filtermenu [items]="filterMenuItemsForDetailedView">
                  <app-worldmap
                      class="card"
                      title= "{{ 'pages.cybersocxdr.dashboard.detailedView.incidentsbycountry' | translate }}"
                      titleY="Handled Incidents"
                      suffix = "incidents"
                      [data]="incidentsRepartitionData"
                      ></app-worldmap>
                </app-filtermenu>
          </div>

            <div class="col-12 col-xl-6 pt-2 pb-4">
              <app-filtermenu [items]="filterMenuItemsForDetailedView">
                <app-sunburst
                    class="card"
                    title= "{{ 'pages.cybersocxdr.dashboard.detailedView.incidentsrepartition' | translate }}"
                    suffix=""
                    innerSize= 0
                    [data]="incidentsRepartitionData"
                    [rootNode]="rootNode"
                    ></app-sunburst>
              </app-filtermenu>
            </div>
          </div>
        <ng-container *ngIf="groupByTypes.length > 1">
          <div class="mx-auto p-2 container-fluid" style="width: 50%; top: -50%;">
            <div class="row">

              <div ngbRadioGroup ngDefaultControl class="btn-group col" role="group" [(ngModel)]="groupByLevel" (change)="search()">
                <input ngbButton type="radio" class="btn-check" name="options" id="1" autocomplete="off" [value]="1" checked>
                <label ngbButtonLabel class="btn" for="1">{{ globalFilters.groupByNames[0] | titlecase }}</label>

                <input ngbButton type="radio" class="btn-check" name="options" id="2" autocomplete="off" [value]="2">
                <label ngbButtonLabel class="btn" for="2" >{{ globalFilters.groupByNames[1] | titlecase }}</label>
              </div>

            </div>
          </div>
        </ng-container>
        <h1 class="container-fluid no-gutters" innerHTML="{{ 'pages.cybersocxdr.dashboard.detailedView.backlog' | translate }}"></h1>
        <div class="col-12 col-xl-6 pb-4">
          <app-filtermenu [items]="filterMenuItemsForDetailedView">
            <app-barovertime
                class="card"
                title= "{{ ('pages.cybersocxdr.dashboard.detailedView.openIncidentByCategory' | translate: {category: globalFilters.groupByNames[groupByLevel-1]}) }}"
                [data]="histogramIncidentsRepartitionData"
                [hovered]="hoveredRow"
                ></app-barovertime>
          </app-filtermenu>
        </div>
        <div class="col-12 col-xl-6 pb-4">
          <app-filtermenu [items]="filterMenuItemsForDetailedView" [disabled]="groupByLevel === '2'">
            <app-table
                class="card"
                style="height: 404px"
                title= "{{ ('pages.cybersocxdr.dashboard.detailedView.topOpenedIncidentsByCategory' | translate: {category: globalFilters.groupByNames[groupByLevel-1]}) }}"
                maxRows="5"
                (rowHoverEvent)="updateHovered($event)"
                [internalColumnsNames]="['name', 'value']"
                [data]="topIncidentsByRepartitionData"
                [columnsNames]="[globalFilters.groupByNames[groupByLevel-1], 'Nb Incidents']"
                ></app-table>
          </app-filtermenu>
        </div>
        <h1 class="container-fluid no-gutters" innerHTML="{{ 'pages.cybersocxdr.dashboard.detailedView.details' | translate }}"></h1>
        <div class="col-lg-6 col-sm-12 position-relative">
          <app-filtermenu [items]="filterMenuItemsForDetailedView">
            <app-polar
                class="card"
                title= "{{ ('pages.cybersocxdr.dashboard.detailedView.openIncidentByCategory' | translate: {category: subGroupbyField}) }}"
                suffix=""
                [data]="groupedIncidentsRepartitionData"
                ></app-polar>
          </app-filtermenu>
          <select class="form-select filter-form" name="groupBy" aria-describedby="groupBy" [(ngModel)]="groupBy" id="groupBy" (change)="updateLeveledGroupBy($event.target.value)">
            <option value="severities">Severities</option>
            <option value="owner">Owners</option>
            <option value="incident_status">Status (Open/Close)</option>
            <option value="xdr_status">Status</option>
            <option value="categories">Categories</option>
            <option value="hostnames">Hostnames</option>
          </select>
        </div>
        <div class="col-lg-6 col-sm-12">
          <app-areaovertime
              class="card"
              title="{{'pages.cybersocxdr.dashboard.detailedView.incidentByCategoryOvertime' | translate: {category: globalFilters.groupByNames[groupByLevel-1]} }}"
              [isStacking]="true"
              titleY="Number of incidents"
              [data]="incidentsOverTimeRepartitionData"
              suffix = "incidents"
              ></app-areaovertime>
        </div>
      </ng-template>
    </div>
</div>
